import { BoxDashboardKpiEntity } from "@/modules/boxDashboard/modules/KPI/entities/boxDashboardKpiEntity"
import { useServicesContext } from "@/modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"
import type { Dayjs } from "dayjs"

export const useKPI = (period: { baseline: Dayjs; comparison: Dayjs }) => {
  const { boxDashboardApi } = useServicesContext()
  const periodDto = {
    baseline: {
      year: period.baseline.year(),
      month: period.baseline.month() + 1,
    },
    comparison: {
      year: period.comparison.year(),
      month: period.comparison.month() + 1,
    },
  }

  const query = useSuspenseQuery({
    queryKey: ["kpi", periodDto],
    queryFn: async () => {
      const dto = await boxDashboardApi.getKPI(periodDto)

      return BoxDashboardKpiEntity.fromDto(dto)
    },
  })

  return {
    kpi: query.data,
  }
}
